import axios from "axios"
export default {
	namespaced: true,
	state: {
		variables: {
			array: [],
			count: 0
		},
		variable: undefined,
		pagination: {
			size: 50,
			offset: 0
		}
	},
	getters: {
		breadcrumb: state => state.breadcrumb,
		variables: state => state.variables,
		variable: state => state.variable,
		pagination: state => state.pagination
	},
	mutations: {
		mutate(state, payload) {
			state[payload.element] = payload.value
		},

		LOAD(state, payload) {
			state.variables = {
				array: payload.array,
				count: payload.count
			}
		},
		ADD(state, element) {
			if (state.variables.array.length < state.pagination.size) state.variables.array.push(element)
			state.variables.count += 1
		},
		UPDATE(state, payload) {
			state.variables.array[payload.index] = payload.value
		}
	},

	actions: {
		doMutate({ commit }, payload) {
			commit("mutate", payload)
		},

		async doGet({ commit }, payload) {
			await axios
				.post(process.env.VUE_APP_API_URL + "/api/customfields/filters", payload, {
					headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
				})
				.then(({ data }) => {
					const array = data.array.map(d => {
						if (d.rules) {
							d.rules = JSON.parse(d.rules)
						}
						return d
					})
					commit("LOAD", { array, count: data.count })
				})
				.catch(err => console.error(err))
		},

		async doAdd({ commit }, payload) {
			return await axios
				.post(process.env.VUE_APP_API_URL + "/api/customfields/add", payload, {
					headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
				})
				.then(({ data }) => {
					data.rules = JSON.parse(data.rules)
					commit("ADD", data)
					return true
				})
				.catch(err => {
					console.error(err)
					return false
				})
		},

		async doGetById({ commit }, id) {
			await axios
				.get(process.env.VUE_APP_API_URL + "/api/customfields/" + id, {
					headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
				})
				.then(({ data }) => {
					data.rules = JSON.parse(data.rules)
					commit("mutate", { element: "variable", value: data })
				})
				.catch(err => {
					console.error(err)
				})
		}
	}
}
